import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Natural Laws Quiz",
    duration: 15
};

export const module6Questions: QuizQuestion[] = [
    {
        id: "M6-001",
        moduleId: "module-6",
        category: "Gravity",
        text: "Braking distance is naturally ____ when traveling uphill due to gravity.",
        options: ["Longer", "Shorter", "Unchanged", "Double"],
        correctAnswer: 1,
        scenario: "You are driving up a steep residential hill and need to stop at an intersection.",
        explanation: ""
    },
    {
        id: "M6-002",
        moduleId: "module-6",
        category: "Gravity",
        text: "Relying 100% on friction brakes during a long mountain descent leads to ____.",
        options: ["Better fuel economy", "Brake fade and potential failure", "Engine overheating", "Tire wear"],
        correctAnswer: 1,
        scenario: "You are descending a long mountain road. To maintain a safe speed, you continuously hold down the service brake pedal.",
        explanation: ""
    },
    {
        id: "M6-003",
        moduleId: "module-6",
        category: "Maintenance",
        text: "Which technique saves your brakes by using engine compression to slow down?",
        options: ["Coasting in Neutral", "Engine Braking (Downshifting)", "Rapid Pumping", "Abrupt Steering"],
        correctAnswer: 1,
        scenario: "You are preparing to descend a steep downgrade and want to prevent your friction brakes from overheating.",
        explanation: ""
    },
    {
        id: "M6-004",
        moduleId: "module-6",
        category: "Physics",
        text: "The first physical sign of 'Brake Fade' is often a ____ pedal feel.",
        options: ["Firm", "Vibrating", "Spongy or Soft", "Sharp"],
        correctAnswer: 2,
        scenario: "Halfway down a steep descent, you tap the brake pedal and notice it feels unusually soft, sinking almost to the floor.",
        explanation: ""
    },
    {
        id: "M6-005",
        moduleId: "module-6",
        category: "Physics",
        text: "Kinetic energy quadruples when speed is ____.",
        options: ["Tripled", "Doubled", "Increased by 10%", "Squared"],
        correctAnswer: 1,
        scenario: "You accelerate your vehicle from 20 mph to 40 mph. A passenger asks how this speed differential affects your vehicle's physical momentum.",
        explanation: "Kinetic energy is proportional to the square of your speed. Doubling your speed quadruples your kinetic energy, meaning your vehicle has four times the stopping and impact force."
    },
    {
        id: "M6-006",
        moduleId: "module-6",
        category: "Physics",
        text: "At 60 MPH, your brakes must work ____ times harder than at 20 MPH to stop.",
        options: ["3", "6", "9", "12"],
        correctAnswer: 2,
        scenario: "You are driving at 60 mph and compare your stopping physics to driving at 20 mph. How much harder must your brakes work to stop?",
        explanation: "Tripling your speed from 20 to 60 mph increases your kinetic energy by nine times (3 squared = 9). Your brakes must convert nine times the thermal heat to stop the vehicle's mass."
    },
    {
        id: "M6-007",
        moduleId: "module-6",
        category: "Physics",
        text: "Hitting a solid object at 70 MPH is equivalent to driving off a ____ building.",
        options: ["3-story", "5-story", "12-story", "20-story"],
        correctAnswer: 2,
        scenario: "A classmate asks you why hitting a solid wall at 70 mph is so catastrophic compared to standard highway speeds.",
        explanation: "Under natural physics laws, hitting a solid, unyielding object at 70 mph subjects the vehicle and occupants to an impact force equivalent to driving off the roof of a 12-story building."
    },
    {
        id: "M6-008",
        moduleId: "module-6",
        category: "Maintenance",
        text: "Brakes are energy converters that change motion into ____.",
        options: ["Sound", "Heat", "Light", "Fuel"],
        correctAnswer: 1,
        scenario: "A passenger asks you how the vehicle's braking system physically stops a moving car.",
        explanation: ""
    },
    {
        id: "M6-009",
        moduleId: "module-6",
        category: "Traction",
        text: "Every maneuver relies on 'Contact Patches' of rubber no larger than a ____.",
        options: ["Sheet of paper", "Postcard", "Small laptop", "Dinner plate"],
        correctAnswer: 1,
        scenario: "You are driving at highway speeds. A friend notes that modern vehicles are so heavy, their grip on the road must be massive.",
        explanation: ""
    },
    {
        id: "M6-010",
        moduleId: "module-6",
        category: "Traction",
        text: "What is 'Summer Ice'?",
        options: ["Ice found in high altitudes", "A slick film of oil and grease lifted by rain after a dry spell", "Frozen coolant", "Snow that hasn't melted"],
        correctAnswer: 1,
        scenario: "It starts to rain lightly after a dry, hot summer month. Why is the road surface particularly slick right now?",
        explanation: ""
    },
    {
        id: "M6-011",
        moduleId: "module-6",
        category: "Traction",
        text: "Hydroplaning can begin at speeds as low as ____.",
        options: ["20 MPH", "35 MPH", "55 MPH", "70 MPH"],
        correctAnswer: 1,
        scenario: "You are driving in heavy rain on the highway at 45 mph. Your passenger says you don't need to worry about hydroplaning below 55 mph.",
        explanation: ""
    },
    {
        id: "M6-012",
        moduleId: "module-6",
        category: "Traction",
        text: "At 55 MPH in heavy rain, your tires may lose ____% of their contact with the road.",
        options: ["25%", "50%", "75%", "100%"],
        correctAnswer: 3,
        scenario: "You are traveling in heavy rain at 55 mph. How much grip do your tires actually have with the asphalt?",
        explanation: ""
    },
    {
        id: "M6-013",
        moduleId: "module-6",
        category: "Recovery",
        text: "If your car starts to hydroplane, you should ____.",
        options: ["Slam the brakes", "Turn the wheel sharply", "Ease off the gas and stay straight", "Shift to Reverse"],
        correctAnswer: 2,
        scenario: "Your steering suddenly feels completely light and unresponsive in heavy rain, indicating your vehicle is hydroplaning.",
        explanation: ""
    },
    {
        id: "M6-014",
        moduleId: "module-6",
        category: "Physics",
        text: "The law of inertia states that objects in motion want to ____.",
        options: ["Stop", "Speed up", "Stay in motion in a straight line", "Turn"],
        correctAnswer: 2,
        scenario: "You are steering your sedan into a sharp left turn, but the vehicle starts drifting straight towards the outer guardrail.",
        explanation: ""
    },
    {
        id: "M6-015",
        moduleId: "module-6",
        category: "Physics",
        text: "What force pulls your car toward the center of a curve?",
        options: ["Inertia", "Centrifugal Force", "Centripetal Force", "Gravity"],
        correctAnswer: 2,
        scenario: "A classmate asks you what physical force keeps your car moving in a circular path during a turn.",
        explanation: ""
    },
    {
        id: "M6-016",
        moduleId: "module-6",
        category: "Road Design",
        text: "Which road design uses gravity to help pull the vehicle into a turn?",
        options: ["Banked Curve", "Crowned Road", "Flat Intersection", "Gore Area"],
        correctAnswer: 0,
        scenario: "You are driving on a modern highway curve that tilts downward toward the inside edge of the turn. How does this help control the vehicle?",
        explanation: ""
    },
    {
        id: "M6-017",
        moduleId: "module-6",
        category: "Road Design",
        text: "Crowned roads are high in the center for water runoff and pull you toward the ____.",
        options: ["Centerline", "Shoulder (Outside)", "Sky", "Left"],
        correctAnswer: 1,
        scenario: "You are driving on a rural two-way road during a rainstorm. You notice the center of the road is sloped downward toward the shoulders.",
        explanation: ""
    },
    {
        id: "M6-018",
        moduleId: "module-6",
        category: "Strategy",
        text: "The 'Enter Smooth' rule says you should do all your braking ____.",
        options: ["Inside the curve", "BEFORE entering the curve", "Only at the apex", "When you feel the slide"],
        correctAnswer: 1,
        scenario: "You are approaching a high-speed curve on a country road. Your passenger says you can brake during the turn to manage speed.",
        explanation: ""
    },
    {
        id: "M6-019",
        moduleId: "module-6",
        category: "Physics",
        text: "Which vehicle type has a higher center of gravity and is more likely to rollover?",
        options: ["Compact Sedan", "Sports Car", "SUV or Truck", "Hybrid Hatchback"],
        correctAnswer: 2,
        scenario: "You are driving an SUV down a steep hill with sharp curves. How does your vehicle type affect your speed choice?",
        explanation: ""
    },
    {
        id: "M6-020",
        moduleId: "module-6",
        category: "Physics",
        text: "Centrifugal force is actually an illusion caused by your body's ____.",
        options: ["Gaze", "Inertia", "Gravity", "Weight"],
        correctAnswer: 1,
        scenario: "During a sharp curve, you feel a strong physical force pulling your body outward toward the passenger door.",
        explanation: ""
    },
    {
        id: "M6-021",
        moduleId: "module-6",
        category: "Strategy",
        text: "What is 'defensive driving'?",
        options: [
            "Driving aggressively to protect your lane position",
            "Driving to anticipate hazards, recognize risks, and make safe adjustments regardless of others' errors",
            "Honking at distracted road users",
            "Speeding through yellow lights to avoid being hit from behind"
        ],
        correctAnswer: 1,
        scenario: "Another motorist cuts you off at an intersection. Your passenger suggests you honk and tail them to defend your lane position.",
        explanation: ""
    },
    {
        id: "M6-022",
        moduleId: "module-6",
        category: "Strategy",
        text: "In risk management, what is 'risk separation'?",
        options: [
            "Driving as far away from police cars as possible",
            "Handling multiple hazards one at a time by adjusting speed or position to avoid meeting them simultaneously",
            "Driving in a separate lane from all traffic",
            "Tailgating large semi-trucks"
        ],
        correctAnswer: 1,
        scenario: "You are driving past a cyclist while an oncoming truck approaches. How should you manage these two hazards?",
        explanation: ""
    },
    {
        id: "M6-023",
        moduleId: "module-6",
        category: "Strategy",
        text: "Which of the following is the first step in the SEE (Search, Evaluate, Execute) space management system?",
        options: [
            "Slamming on the brakes",
            "Searching your surroundings for potential hazards up to 20-30 seconds ahead",
            "Speeding up to merge",
            "Honking to clear traffic"
        ],
        correctAnswer: 1,
        scenario: "You are piloting a vehicle through a commercial zone with heavy cross traffic. What is your first priority under the SEE system?",
        explanation: ""
    },
    {
        id: "M6-024",
        moduleId: "module-6",
        category: "Strategy",
        text: "What is 'risk minimization' when driving past parked cars?",
        options: [
            "Speeding up to get past them quickly",
            "Steering closer to them to make room for oncoming lanes",
            "Adjusting your lane position to create a wider safety buffer in case a door suddenly opens",
            "Turning on high beams"
        ],
        correctAnswer: 2,
        scenario: "You are driving down a narrow city street lined with closely parked cars. What is your primary defensive adjustment?",
        explanation: ""
    },
    {
        id: "M6-025",
        moduleId: "module-6",
        category: "Strategy",
        text: "How does driving fatigue impact your risk assessment and hazard-processing capabilities?",
        options: [
            "It sharpens your peripheral vision",
            "It degrades reaction times and leads to poor judgment and slower recognition of hazards",
            "It has no impact on experienced drivers",
            "It decreases sleep debt"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Fatigue severely degrades your brain\\'s processing capabilities, causing slower hazard recognition, delayed physical reactions, and compromised spatial judgment.**",
        explanation: ""
    }
];
